import type { ImpiantiPaginationDTO } from '@/models/dto/impianto/impianti-pagination-dto'
import type { FacilitiesWithPagination } from '@/models/types/facility/facilities-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToFacility, mapToImpiantoDTO } from './facility-mapper'

const mapToImpiantiDTO = (facilities: FacilitiesWithPagination): ImpiantiPaginationDTO => {
    return {
        impianti: facilities.facilities?.map((facility) => mapToImpiantoDTO(facility)),
        paginationData: facilities.pagination ? mapToPaginationDTO(facilities.pagination) : null,
    }
}

const mapToFacilities = (impiantiDTO: ImpiantiPaginationDTO): FacilitiesWithPagination => {
    return {
        facilities: impiantiDTO.impianti?.map((impianto) => mapToFacility(impianto)),
        pagination: impiantiDTO.paginationData ? mapToPagination(impiantiDTO.paginationData) : undefined,
    }
}

export { mapToFacilities, mapToImpiantiDTO }
